import { useTranslation } from 'react-i18next';
import { useEventMutation } from '@hooks/use-event-mutation';
import { useToast } from '@hooks/use-toast/use-toast';
import { useEventUIStore } from '@stores/event-ui-store';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';
import { GroupCreateResponse } from './use-create-group';

const removeOfferFromGroup = async (offerGroupId: string, offerId: string) => {
  return await request({
    url: `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/offer-groups/${offerGroupId}/offers/${offerId}`,
    method: RequestMethod.DELETE,
  });
};

export const useRemoveOfferFromGroup = ({ eventId }: { eventId?: string }) => {
  const { t } = useTranslation();
  const toast = useToast();
  return useEventMutation<GroupCreateResponse, RequestError, { groupId: string; offerId: string }>(
    [QUERY_KEYS.removeOfferFromGroup],
    async ({ groupId, offerId }) => removeOfferFromGroup(groupId, offerId),
    {
      eventId,
      onSuccess: (_data, { offerId }) => {
        useEventUIStore.getState().setScrollTargetId(offerId);

        toast.push({
          title: t('admissionGroups:removeAdmissionFromGroupSuccessMessage'),
          text: '',
          type: 'success',
        });
      },
    }
  );
};
